"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatIcon = ChatIcon;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = require("../../../components/Icon/Icon");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ChatIcon(_ref) {
  var unread = _ref.unread,
    iconClassName = _ref.iconClassName;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "relative"
  }, unread !== null && unread !== void 0 && unread.oneToOneChannels ? /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('absolute bottom-3/4 left-1/2 rounded-full', 'py-[1px] px-[6px] tw-caption-regular text-[10px] bg-green1-10 text-green1-70 radius')
  }, unread.oneToOneChannels) : null, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    type: "chat",
    className: iconClassName
  }));
}